module.exports = __webpack_public_path__ + "img/payment-visa-comafi-chicas.88776551.png";